/* global globalThis */
import URL from "./apiURL";
import { authenticatedFetch } from "../../utils/authenticatedFetch";
import { getValidToken } from "../../utils/getValidToken";

export async function userDetailsAPI(requestPayload) {
  try {
    return await authenticatedFetch(URL.UserApi, {
      method: "POST",
      body: JSON.stringify(requestPayload)
    });
  } catch (error) {
    const errorMessage = String(error?.message || "");
    const shouldUseFallback =
      errorMessage.includes("name 'g' is not defined") ||
      errorMessage.includes("500");

    // Temporary fallback while /api/user_details backend route is unstable.
    if (shouldUseFallback) {
      try {
        return await authenticatedFetch(URL.adminApi, {
          method: "GET",
        });
      } catch (fallbackError) {
        console.error("Error fetching user (fallback failed):", fallbackError.message);
        throw fallbackError;
      }
    }

    console.error("Error fetching user:", error.message);
    throw error;
  }
}

export async function createUserAPI(newUser) {
  try {
    return await authenticatedFetch(URL.CreateUserApi, {
      method: "POST",
      body: JSON.stringify(newUser)
    });
  } catch (error) {
    console.error("Error creating user:", error.message);
    throw error;
  }
}

export async function editUserAPI(updatedUser, userId) {
  try {
    return await authenticatedFetch(`${URL.EditUserApi}/${userId}`, {
      method: "PUT",
      body: JSON.stringify(updatedUser),
    });
  } catch (error) {
    console.error("Error updating user:", error.message);
    throw error;
  }
}

export async function deleteUserAPI(userId) {
  try {
    return await authenticatedFetch(`${URL.DeleteUserApi}/${userId}`, {
      method: "DELETE",
    });
  } catch (error) {
    console.error("Error deleting user:", error.message);
    throw error;
  }
}

export async function deleteMultiUserAPI(userIdList) {
  try {
    return await authenticatedFetch(URL.DeleteAllUserApi, {
      method: "DELETE",
      body: JSON.stringify(userIdList),
    });
  } catch (error) {
    console.error("Error deleting multiple users:", error.message);
    throw error;
  }
}

/**
 * Function to call Admin export to excel API
 * @param {Filter data} filterData
 * @returns 
*/

export async function exportToExcelFile(filterData) {
  const requestObj = {
    filters: filterData,
  }
  const token = await getValidToken();

  try {
    const response = await fetch(URL.ExportUserApi, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(requestObj),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();

    const url = globalThis.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "user_details.xlsx");
    document.body.appendChild(link);
    link.click();

    link.remove();
    globalThis.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Error fetching data:", error.message);
    throw error;
  }

}